// extracted by mini-css-extract-plugin
module.exports = {"title":"forgotPassword_title__2FXdf","text":"forgotPassword_text__1tqgp","dialog":"forgotPassword_dialog__1JrDv"};
    if(module.hot) {
      // 1783591926483
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  